export const FilterColumns = (columns, hiddenColumns, showCustomCols, TableColumnExtensions, isRowDetailPresent, dispatch) => {
    if (!showCustomCols) {
        const width = window.innerWidth;
        const currentColumnCount = columns.length;

        let columnCount;
        let columnWidths = GetColumnWidthArray(TableColumnExtensions, isRowDetailPresent);

        if (width <= columnWidths[2]) {
            columnCount = 2;
        } else if (width < columnWidths[3]) {
            columnCount = 3;
        } else if (width < columnWidths[4]) {
            columnCount = 4;
        } else if (width < columnWidths[5]) {
            columnCount = 5;
        } else {
            columnCount = 6;
        }

        columns = columns.filter((element) => {
            return !hiddenColumns.includes(element.name);
        });

        if (columnCount !== currentColumnCount || columnCount === 5) {
            hiddenColumns = [...hiddenColumns, ...columns.slice(columnCount).map((c) => c.name)];

            if (columnCount > 2) dispatch({ type: 'DESKTOP_COLUMN_WIDTHS' });
            else dispatch({ type: 'MOBILE_COLUMN_WIDTHS' });

            return hiddenColumns;
        }
    }
    return null;
};

const GetColumnWidthArray = (TableColumnExtensions, isRowDetailPresent) => {
    let columnWidths = [];
    let currIndex = 0;
    let prevIndex = 0;

    TableColumnExtensions.map((element) => {
        if (currIndex === 6) {
        } else if (currIndex !== 0) {
            columnWidths.push(element.width + columnWidths[prevIndex]);
            currIndex++;
            prevIndex++;
        } else {
            let rowDetailValue = isRowDetailPresent ? 55 : 15;
            columnWidths.push(element.width + rowDetailValue);
            currIndex++;
        }
        return null;
    });

    for (var i = currIndex; i < 6; i++) {
        if (i !== 0) {
            columnWidths.push(columnWidths[prevIndex]);
            currIndex++;
            prevIndex++;
        } else {
            let rowDetailValue = isRowDetailPresent ? 55 : 15;
            columnWidths.push(230 + rowDetailValue);
        }
    }

    return columnWidths;
};

export const SortTable = (sorting, sortInfo, dispatch) => {
    let { columnName, direction } = sorting[0];

    if (sortInfo && sortInfo.columnName) {
        if (columnName === sortInfo.columnName) {
            direction = sortInfo.direction === 'asc' ? 'desc' : 'asc';
        }
    }

    dispatch({ type: 'SORT_INFO', sortInfo, columnName, direction });
};

export const ChangeTablePage = (pageSize, dispatch, currentPage, tableSize) => {
    dispatch({ type: 'PAGESIZE', payload: pageSize });

    if (pageSize * currentPage > tableSize) {
        const lastPage = tableSize / pageSize;
        dispatch({ type: 'CURRENT_PAGE', payload: Math.ceil(lastPage) });
    }
};

export const HandlePageLoading = (isLoading) => {
    const table = document.getElementsByTagName('table')[0];

    if (isLoading) {
        table.className += ' loading-table';
    } else {
        table.className = 'table dx-g-bs4-table';
    }
};

export const DeepCopy = (input) => {
    let output, value, key;

    if (typeof input !== 'object' || input === null) {
        return input;
    }

    output = Array.isArray(input) ? [] : {};
    for (key in input) {
        value = input[key];
        output[key] = DeepCopy(value);
    }

    return output;
};
